/**
 * @descrição
 * Componente wrapper (envoltório) reutilizável que padroniza a estrutura das 
 * diferentes visualizações de estado no fluxo de vinculação de usuários.
 * 
 * @props
 * - className: String - Classes CSS a serem aplicadas ao container
 * - children: ReactNode - Conteúdo a ser renderizado dentro do container
 * 
 * @uso
 * É utilizado como base para todos os componentes de visualização de estado,
 * garantindo uma estrutura DOM consistente e facilitando alterações globais
 * na estrutura das telas.
 */
import classes from '../../RescueCode.module.scss';

const StateView = ({ className, children }) => {
  return (
    <section className={className}>
      {children}
    </section>
  );
};

export default StateView;